
import React from "react";
import CheckedIcon from '../../assets/images/checked.svg';
import { Image } from "../../components/componentIndex";

const CheckedImage = () => {
    return (
        <Image imgUrl={CheckedIcon} altText={'checked'} className={'checked'} />
    )
}

export default CheckedImage;